// extracted by mini-css-extract-plugin
export var dataCell = "_lk-2";
export var dataRow = "_lk-0";
export var headerRow = "_lk-1";